import {
  CircleCheckIcon,
  InfoIcon,
  Loader2Icon,
  OctagonXIcon,
  TriangleAlertIcon,
} from "lucide-react";
import type * as React from "react";
import type { ToasterProps } from "sonner";
import { Toaster as Sonner, toast } from "sonner";

// Colors follow the app's semantic tokens, so the toaster needs no theme provider.
// Expanded, because the collapsed stack hides every toast behind the newest one and leaves only
// empty card outlines around it.
const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      expand
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster, toast };
